import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3u7f7kz1: FaireBrandEntity = {
  token: "b_3u7f7kz1",
  type: "brand",
  name: "Golden NYC Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/8dfff7df2c76ac3132aafc71af7a03c93e537b1197fabd232dc92875aa6fa60b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/64f5334cfda9bb0e3420d8fd2c8d9e45f22289d1aeab6f0ead164b4855ec5d77.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8dfff7df2c76ac3132aafc71af7a03c93e537b1197fabd232dc92875aa6fa60b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64f5334cfda9bb0e3420d8fd2c8d9e45f22289d1aeab6f0ead164b4855ec5d77.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 2.9,
  reviewCount: 244,
  isInsider: true,
  description:
    "We believe in the fashion philosophy that you should invest in the essentials and play with trends. So, we created the ultimate playground. Fashion should  be fun we translate the trends you're coveting right now into a wide range of jewelry and accessories. We want to make it easy to experiment with style. Shop best sellers from NYC with love we design everything in our New York City headquarters and introduce new arrivals every Sunday. Updating your wardrobe has never been easier!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.767Z",
    importedBy: "entity-db-cli",
  },
};
